import  { Api } from "../utils";
import { GetParkingRegisters } from '../lib/Parking/';

const ParkingActions = {

  async onLoadParkingRegisters(userCC, actualMonth) {
    const url = `services/app/Employee/GetParking?cc=${userCC}&StartDate=${actualMonth.startDate}&EndDate=${actualMonth.endDate}`;
    try {
      const response = await Api.fetchAsync(url);
      Api.validateResponse(response, url);
      return GetParkingRegisters((await response.json()).result);
    } catch(e) {
      return null;
    }
  },


  async onLoadMonthsWithCutDates() {
    const url = 'services/app/Settings/GetMonths';
    try {
      const response = await Api.fetchAsync(url);
      Api.validateResponse(response, url);
      return (await response.json()).result;
    } catch(e) {
      return null;
    }
  }

};

export default ParkingActions;